export const Flyout = 10000;
export const Tooltip = 1000002;
//# sourceMappingURL=z-index.js.map